import { Box, Flex, FlexProps, IconButton, Text } from '@chakra-ui/react';
import { HiArrowLeft, HiArrowRight } from 'react-icons/hi';

interface PaginationProps extends FlexProps {
  totalCountOfRegisters: number;
  registersPerPage?: number;
  currentPage?: number;
  onPageChange: (page: number) => void;
}

export function Pagination({
  totalCountOfRegisters,
  currentPage = 1,
  registersPerPage = 10,
  onPageChange,
  ...props
}: PaginationProps) {
  const lastPage = Math.max(
    1,
    Math.ceil(totalCountOfRegisters / registersPerPage),
  );

  if (lastPage <= 1) return null;

  const canPrev = currentPage > 1;
  const canNext = currentPage < lastPage;

  return (
    <Flex justify="center" align="center" gap="24px" mt="48px" {...props}>
      <IconButton
        aria-label="Página anterior"
        icon={<HiArrowLeft />}
        variant="ghost"
        isDisabled={!canPrev}
        onClick={() => onPageChange(currentPage - 1)}
        bg="transparent"
        color="text.muted"
        borderWidth="1px"
        borderColor="line.subtle"
        borderRadius="2px"
        _hover={{
          borderColor: 'accent.500',
          color: 'accent.500',
          bg: 'transparent',
        }}
        _disabled={{ opacity: 0.3, cursor: 'not-allowed' }}
      />

      <Box
        fontFamily="mono"
        fontSize="13px"
        letterSpacing="0.08em"
        color="text.muted"
        minW="60px"
        textAlign="center"
      >
        <Text as="span" color="text.primary">
          {String(currentPage).padStart(2, '0')}
        </Text>{' '}
        / {String(lastPage).padStart(2, '0')}
      </Box>

      <IconButton
        aria-label="Próxima página"
        icon={<HiArrowRight />}
        variant="ghost"
        isDisabled={!canNext}
        onClick={() => onPageChange(currentPage + 1)}
        bg="transparent"
        color="text.muted"
        borderWidth="1px"
        borderColor="line.subtle"
        borderRadius="2px"
        _hover={{
          borderColor: 'accent.500',
          color: 'accent.500',
          bg: 'transparent',
        }}
        _disabled={{ opacity: 0.3, cursor: 'not-allowed' }}
      />
    </Flex>
  );
}
